import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './i18n';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { usePageTracking } from './hooks/usePageTracking';

function RouteTracker() {
  usePageTracking();
  return null;
}

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import AnalyserPage from './pages/AnalyserPage';
import ResultsPage from './pages/ResultsPage';
import OptimizedCVPage from './pages/OptimizedCVPage';
import CoverLetterPage from './pages/CoverLetterPage';
import PricingPage from './pages/PricingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/inscription" element={<RegisterPage />} />
          <Route path="/tarifs" element={<PricingPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/conditions" element={<TermsPage />} />
          <Route path="/analyser" element={<AnalyserPage />} />
          <Route path="/resultats/:id" element={<ResultsPage />} />

          {/* Protected Routes */}
          <Route path="/tableau-de-bord" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/cv-optimise/:id" element={
            <ProtectedRoute>
              <OptimizedCVPage />
            </ProtectedRoute>
          } />
          <Route path="/lettre/:id" element={
            <ProtectedRoute>
              <CoverLetterPage />
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
